<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4 mx-1 py-1" v-for="(person, idx) in persons" :key="idx">
        <div class="col-span-12" v-if="person.entityType === 'CORPORATE'">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-3 py-1">
              <span class="font-bold">{{person.corporate.registeredName}}</span>
            </div>
            <div class="col-span-2 py-1">
              <span>{{person.corporate.brn}}</span>
            </div>
            <div class="col-span-1">
              <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs"
                    :class="(person.entityType === 'CORPORATE') ? 'bg-primary' : 'bg-orange'">{{person.entityType.toLowerCase()}}</span>
            </div>
            <div class="col-span-4"></div>
            <div class="col-span-2 float-end">
              <button class="btn-primary float-end mx-auto bg-primary px-2 py-1 text-sm rounded-sm text-white" @click="showDetails(idx)">
                <p v-if="selectedId === idx">
                  Show Less
                </p>
                <p v-else>
                  View Details
                </p>
              </button>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 mt-2" v-if="selectedId === idx">
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.corporate.registeredName"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.corporate.brn"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.corporate.primaryEmail"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.corporate.primaryPhone"
                    required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.corporate.dateOfIncorporation"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="cleanEntityType(person.corporate.subType)"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.corporate.countryOfOrigin"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.corporate.addressInCountryOfIncorporation"
                    required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.corporate.registeredPhysicalAddress.district"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    
                    
                    disabled="true"
                    :value="person.corporate.registeredPhysicalAddress.district.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.corporate.registeredPhysicalAddress.region"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    
                    
                    disabled="true"
                    :value="person.corporate.registeredPhysicalAddress.region.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.corporate.registeredPhysicalAddress.subcounty"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    
                    
                    disabled="true"
                    :value="person.corporate.registeredPhysicalAddress.subcounty.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.corporate.registeredPhysicalAddress.parish"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    
                    
                    disabled="true"
                    :value="person.corporate.registeredPhysicalAddress.parish.name"
                    required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.corporate.registeredPhysicalAddress.village"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    
                    
                    disabled="true"
                    :value="person.corporate.registeredPhysicalAddress.village.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.corporate.registeredAddress"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.corporate.registeredAddress.postalAddress"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.corporate.registeredAddress"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.corporate.registeredAddress.plot"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.corporate.registeredAddress"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.corporate.registeredAddress.street"
                    required>
                </input>
              </div>

            </div>
          </div>
        </div>
        <div class="col-span-12" v-if="person.entityType === 'INDIVIDUAL'">
          <div class="grid grid-cols-12 gap-4">
            <div class="col-span-3 py-1">
              <span class="font-bold">{{person.individual.givenName}} {{person.individual.surName}}</span>
            </div>
            <div class="col-span-2 py-1">
              <span>{{person.individual.idNumber}}</span>
            </div>
            <div class="col-span-1">
              <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs"
                    :class="(person.entityType === 'CORPORATE') ? 'bg-primary' : 'bg-orange'">{{person.entityType.toLowerCase()}}</span>
            </div>
            <div class="col-span-4"></div>
            <div class="col-span-2">
              <button class="btn-primary float-end mx-auto bg-primary px-2 py-1 text-sm rounded-sm text-white" @click="showDetails(idx)">
                <p v-if="selectedId === idx">
                  Show Less
                </p>
                <p v-else>
                  View Details
                </p>
              </button>
            </div>
          </div>
          <div class="grid grid-cols-12 gap-4 mt-2" v-if="selectedId === idx">
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.givenName"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.individual.middleName"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.middleName"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.surName"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.idType.toLowerCase()"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.idNumber"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.nationality"
                    required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.email"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.phoneNumber"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.sex.toLowerCase()"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="dateFormat(person.individual.dateOfBirth)"
                    required>
                </input>
                <div class="text-sm text-gray-600 mt-1">
                  {{person.individual.age}}
                </div>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.occupation"
                    required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.individual.address.physicalAddress"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    
                    
                    disabled="true"
                    :value="person.individual.address.physicalAddress.district.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.individual.address.physicalAddress"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    
                    
                    disabled="true"
                    :value="person.individual.address.physicalAddress.region.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.individual.address.physicalAddress"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    
                    
                    disabled="true"
                    :value="person.individual.address.physicalAddress.subcounty.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.individual.address.physicalAddress"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    
                    
                    disabled="true"
                    :value="person.individual.address.physicalAddress.parish.name"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.individual.address.physicalAddress"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    
                    
                    disabled="true"
                    :value="person.individual.address.physicalAddress.village.name"
                    required>
                </input>
              </div>
            </div>
            <div class="col-span-12">
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.individual.address.postalAddress"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.address.postalAddress"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.individual.address.street"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.address.street"
                    required>
                </input>
              </div>
              <div class="flex flex-col gap-2 text-sm my-1" v-if="person.individual.address.plot"
                  
                  id="input-group-1">
                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                    id="companyName"
                    
                    
                    disabled="true"
                    :value="person.individual.address.plot"
                    required>
                </input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { cleanEntityType, dateFormat } from "@/commons/composables/utilities";

defineProps<{ persons: any[] }>();

const selectedId = ref<number | null>(null);

const showDetails = (id: number) => {
  if (selectedId.value != null) {
    selectedId.value = null;
  } else {
    selectedId.value = id;
  }
}
</script>

